<script setup lang="ts">
import { computed } from 'vue'

import type { ReportColumn } from '../../../models/column.types'
import type { ReportRow } from '../../../models/report.types'
import { readBadgeCell } from '../../../service/structuredCells'

const props = defineProps<{
  row: ReportRow
  column: ReportColumn
}>()

const cell = computed(() => readBadgeCell(props.row[props.column.field]))
</script>

<template>
  <!--
    Follow the cell's own alignment rule -- `Td` derives `numeric ? 'end' : 'start'` -- rather
    than pinning every badge to the end. v3's markup reads `justify-end`, but its columns hug
    their content, so on screen its badges share a left edge; a fixed-width column exposes the
    difference.
  -->
  <div
    class="report-badge-cell flex w-full items-center gap-xs text-xs font-semibold"
    :class="column.numeric ? 'justify-end' : 'justify-start'"
  >
    <span v-if="cell.text" class="report-badge-cell__label">{{ cell.text }}</span>
    <span class="report-badge-cell__chip min-w-0 max-w-full truncate rounded-sm px-2xs py-3xs">{{
      cell.badge
    }}</span>
  </div>
</template>

<style scoped>
.report-badge-cell__label {
  color: var(--ui-color-chip-orange);
}
.report-badge-cell__chip {
  border: 1px solid color-mix(in srgb, var(--ui-color-chip-orange) 35%, var(--ui-color-surface));
  background: var(--ui-color-chip-orange-soft);
  color: var(--ui-color-chip-orange);
  font-size: 0.6875rem;
}
</style>
